import { render, staticRenderFns } from "./AccessibilityStatement.vue?vue&type=template&id=01dc458d&scoped=true&"
import script from "./AccessibilityStatement.vue?vue&type=script&lang=js&"
export * from "./AccessibilityStatement.vue?vue&type=script&lang=js&"
import style0 from "./AccessibilityStatement.vue?vue&type=style&index=0&id=01dc458d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dc458d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01dc458d')) {
      api.createRecord('01dc458d', component.options)
    } else {
      api.reload('01dc458d', component.options)
    }
    module.hot.accept("./AccessibilityStatement.vue?vue&type=template&id=01dc458d&scoped=true&", function () {
      api.rerender('01dc458d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/AccessibilityStatement.vue"
export default component.exports